var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-status",class:("invoice-status--" + (_vm.getStatus()))},[_vm._v(_vm._s(_vm.getStatus()))])}
var staticRenderFns = []

export { render, staticRenderFns }